import { render, staticRenderFns } from "./InlineUserCard.vue?vue&type=template&id=29a52ca8&"
import script from "./InlineUserCard.vue?vue&type=script&lang=js&"
export * from "./InlineUserCard.vue?vue&type=script&lang=js&"
import style0 from "./InlineUserCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports